import { createFileRoute } from "@tanstack/react-router";
import { ORG } from "@/app/capabilities/permissions";
import { requireBillingPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade"
)({
  // The parent billing route already enforced the capability and `billing_read`;
  // upgrading the plan is a billing write, so additionally require `billing_update`.
  beforeLoad: (ctx) => requireBillingPermission(ctx, ORG.billing.update),
  loader: () => ({
    crumb: "Upgrade",
  }),
});
